<script>
    export let SERVER;
    export let staff;
</script>

<div class="staff card text-light">
    <img src="{SERVER}/storage/{staff.avatar}" alt="{staff.name}">
    <div class="card-body">
      <div class="text-nowrap">{staff.role}</div>
      <h3 class="card-title text-nowrap">{staff.name}</h3>
      <p class="card-text text-muted"></p>
    </div>
    <div class="card-footer">
      {#if staff.links.facebook}
        <a href="{staff.links.facebook}"><i class="bi-facebook"></i></a>
      {/if}
      {#if staff.links.twitter}
        <a href="{staff.links.twitter}"><i class="bi-twitter"></i></a>
      {/if}
      {#if staff.links.linkedin}
        <a href="{staff.links.linkedin}"><i class="bi-linkedin"></i></a>
      {/if}
    </div>
</div>

<style>
  .staff {
    background-color: #4056A1;
  }

  /* https://stackoverflow.com/questions/37287153/how-to-get-images-in-bootstraps-card-to-be-the-same-height-width */
  .staff img {
    width: 100%;
    height: 60vh;
    object-fit: cover;
  }

  @media (min-width: 576px) {
    .staff img {
      height: 26vw;
    }
  }

  .card-footer a {
    color: var(--bs-text-color-light);
  }
</style>
